import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { animated } from "@react-spring/three";
import { MeshDistortMaterial } from "@react-three/drei";

export default function PointerCommand({ 
  position=[0,0,0], 
  rotation=[Math.PI,0,0], 
  scale=1, 
  color, 
  opacity=1,
  animate=true
}) {
  const ref0 = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const pointerGroup = useRef(null);
  
  const baseHSL = useMemo(() => {
    const c = new THREE.Color(color);
    const hsl = { h: 0, s: 0, l: 0 };
    c.getHSL(hsl);
    return hsl;
  }, [color]);


  useFrame((state, delta) => {
    if (animate) {
      if (ref0.current) {
        ref0.current.rotation.y = state.clock.elapsedTime
        // ref0.current.position.y = positionTopLeft[1] + 0.2 * Math.sin(state.clock.elapsedTime * 3);

        ref0.current.material.color.setHSL(
          baseHSL.h + 0.005 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.s + 0.2 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.l 
        );
      }
      if (ref1.current) {
        ref1.current.rotation.y = state.clock.elapsedTime
        // ref1.current.position.y = positionTopRight[1] + 0.2 * Math.sin(state.clock.elapsedTime * 3);

        ref1.current.material.color.setHSL(
          baseHSL.h + 0.005 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.s + 0.2 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.l 
        );
      }
      if (ref2.current) {
        ref2.current.rotation.y = state.clock.elapsedTime
        // ref2.current.position.y = positionBottomLeft[1] + 0.2 * Math.sin(state.clock.elapsedTime * 3);

        ref2.current.material.color.setHSL(
          baseHSL.h + 0.005 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.s + 0.2 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.l 
        );
      }
      if (ref3.current) {
        ref3.current.rotation.y = state.clock.elapsedTime
        // ref3.current.position.y = positionBottomRight[1] + 0.2 * Math.sin(state.clock.elapsedTime * 3);

        ref3.current.material.color.setHSL(
          baseHSL.h + 0.005 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.s + 0.2 * Math.sin(state.clock.elapsedTime * 3),
          baseHSL.l 
        );
      }
      if (pointerGroup.current) {
        pointerGroup.current.rotation.y = state.clock.elapsedTime * 0.3
        pointerGroup.current.scale.x = scale + 0.05 * Math.sin(state.clock.elapsedTime * 3);
        pointerGroup.current.scale.y = scale + 0.05 * Math.sin(state.clock.elapsedTime * 3);
        pointerGroup.current.scale.z = scale + 0.05 * Math.sin(state.clock.elapsedTime * 3);
      }
    }
  })

  const radius = 0.45
  const coneArgs = [0.06, 0.11, 3]
  return <group ref={pointerGroup}>
    <group rotation={[0, Math.PI / 4, 0]} position={[-radius, 0, -radius]}>
      <mesh 
        ref={ref0} 
        receiveShadow 
        position={position} 
        rotation={rotation}
        scale={scale}>
        <coneGeometry args={coneArgs}/>
        <meshBasicMaterial color={color} transparent opacity={opacity}/>
      </mesh>
    </group>
    <group rotation={[0, - Math.PI / 4, 0]} position={[radius, 0, -radius]}>
      <mesh 
        ref={ref1} 
        receiveShadow 
        position={position} 
        rotation={rotation}
        scale={scale}>
        <coneGeometry args={coneArgs}/>
        <meshBasicMaterial color={color} transparent opacity={opacity}/>
      </mesh>
    </group>
    <group rotation={[0, - 3 * Math.PI / 4, 0]} position={[radius, 0, radius]}>
      <mesh 
        ref={ref2} 
        receiveShadow 
        position={position} 
        rotation={rotation}
        scale={scale}>
        <coneGeometry args={coneArgs}/>
        <meshBasicMaterial color={color} transparent opacity={opacity}/>
      </mesh>
    </group>
    <group rotation={[0, - 5 * Math.PI / 4, 0]} position={[-radius, 0, radius]}>
      <mesh 
        ref={ref3} 
        receiveShadow 
        position={position} 
        rotation={rotation}
        scale={scale}>
        <coneGeometry args={coneArgs}/>
        <meshBasicMaterial color={color} transparent opacity={opacity}/>
      </mesh>
    </group>
  </group>
}